// Single source of truth for which chart types support the y-axis
// "Stack values" option. Mirrors the Wagtail blocks: only Column, Bar and
// Polar have a y_axis_stack_values field (src/main/blocks/data_visualization.py).
// Area stacks via its own stacking_type field; Line never stacks.
export const STACK_VALUES_CHART_TYPES = ['column', 'bar', 'polar'];

export const supportsStackValues = (chartType) =>
    STACK_VALUES_CHART_TYPES.includes(chartType);

// Resolve the Highcharts plotOptions.series.stacking value for the preview.
// Must match what the published renderer does: a stale stackValues flag left
// over from a previous chart type selection must not stack the chart.
export const getSeriesStacking = (config) => {
    if (supportsStackValues(config.chartType)) {
        return config.yAxis?.stackValues ? 'normal' : undefined;
    }
    if (config.chartType === 'area') {
        if (config.stackingType === 'percent') return 'percent';
        if (config.stackingType === 'normal') return 'normal';
    }
    return undefined;
};
